// Firebase configuration
// Replace with your actual Firebase config
export const firebaseConfig = {
  apiKey: "your-api-key",
  authDomain: "your-project-id.firebaseapp.com",
  projectId: "your-project-id",
  storageBucket: "your-project-id.appspot.com",
  messagingSenderId: "your-sender-id",
  appId: "your-app-id",
};

// Node.js backend API configuration
// In development with proxy, use empty string to make relative requests
// In production or with REACT_APP_API_URL set, use the full URL
export const API_BASE_URL =
  process.env.NODE_ENV === "development" && !process.env.REACT_APP_API_URL
    ? "" // Use proxy in development
    : process.env.REACT_APP_API_URL || "http://localhost:3000";

// Debug: Log environment variables
console.log("Environment Variables Loaded:");
console.log("REACT_APP_API_URL:", process.env.REACT_APP_API_URL);
console.log("NODE_ENV:", process.env.NODE_ENV);
console.log("Using API_BASE_URL:", API_BASE_URL);

export const API_ENDPOINTS = {
  auth: "/api/auth",
  users: "/api/users",
  data: "/api/data",
};
